import React from 'react';
import type {FieldRequiredSimple} from 'schemaDefinition/types';
import {isNullish} from 'services/utils';
import {Layout} from 'components/layout';
import type {TextFieldProps} from '../types';
import type {BaseFieldProps} from './types';
import {TextArea} from '../text';
import {FieldLabel} from './FieldLabel';

type Props = BaseFieldProps &
  Pick<TextFieldProps, 'placeholder' | 'onChange' | 'onBlur'> &
  Required<Pick<TextFieldProps, 'name'>> & {
    value: string | null;
    required?: FieldRequiredSimple;
    maxLength?: number;
    rows?: number;
  };

export const TextAreaField: React.FC<Props> = ({
  label,
  placeholder,
  name,
  value,
  required = false,
  error = false,
  readonly,
  maxLength,
  rows,
  layout,
  ...props
}) => {
  return (
    <div>
      {/* Label and count */}
      {isNullish(maxLength) ? (
        label ? (
          <FieldLabel
            label={label}
            required={required}
            error={error}
            htmlFor={name}
          />
        ) : null
      ) : label ? (
        <Layout
          {...layout}
          horizontal
          adjustCenter
          justifyContent={'space-between'}>
          <FieldLabel
            label={label}
            required={required}
            error={error}
            htmlFor={name}
          />
          <FieldLabel label={`${value?.length}/${maxLength}`} />
        </Layout>
      ) : (
        <Layout {...layout} horizontal adjustCenter adjustRight>
          <FieldLabel label={`${value?.length}/${maxLength}`} />
        </Layout>
      )}
      <TextArea
        name={name}
        placeholder={placeholder}
        value={value}
        readonly={readonly}
        error={error === true}
        warning={error === 'warning'}
        maxLength={maxLength}
        rows={rows}
        required={required === true}
        {...props}
      />
    </div>
  );
};
